export default __webpack_public_path__ + "static/media/multi-device-mockup.b62293cd.png";